<div class="flex-align-center gap-S">
    <app-display-user-logo [user]="user" [size]="size"></app-display-user-logo>
    <div *ngIf="!user || (user && user.account.email !== user.account.firstName && user.account.email !== user.account.lastName)" class="flex-column flex-space-evenly" [ngStyle]="{'width': width ? width : 'calc(100% - 10px - ' + size + 'px)', 'height': size + 'px'}">
        <span class="font-M text-overflow-ellipsis" [ngClass]="{'fw-500': !bold, 'fw-700': bold}">
            {{!user ? 'Kabeen' : user.account.firstName + ' ' + user.account.lastName}}
        </span>
        <span *ngIf="user && email" class="font-S fw-500 text-overflow-ellipsis">
            {{user.account.email}}
        </span>
    </div>
	<div *ngIf="user && (user.account.email === user.account.firstName || user.account.email === user.account.lastName)" class="flex-column flex-space-evenly" [ngStyle]="{'width': width ? width : 'calc(100% - 10px - ' + size + 'px)', 'height': size + 'px'}">
        <span class="font-M text-overflow-ellipsis" [ngClass]="{'fw-500': !bold, 'fw-700': bold}">
            {{user.account.email}}
        </span>
	</div>
    <div *ngIf="provider && user && user.account.provider && user.account.provider !== 'local'">
        <img [tooltip]="'modules.displayUser.microsoftSsoEnable' | translate" alt="Microsoft SSO" height="16" ngSrc="assets/icons/shield.svg" width="13"/>
    </div>
</div>
